import $ from 'jquery';

Drupal.behaviors.ajaxProcess = {
  attach() {
    const location = $('#market_selector_location').once('ajaxProcess');
    const form = $('#market-selector-form');
    const submit = form.find('input[type="submit"]');

    location.on('select2:selecting', () => {
      submit.attr('disabled', true);
      submit.addClass('button__ajax-process');
    });

    submit.attr('disabled', false);
    submit.removeClass('button__ajax-process');
  },
};
